module.exports = __webpack_public_path__ + "img/cashier-ad-05.c0f0dc7e.png";